// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"500":"b7ad7736","978":"65c82200"}[chunkId] + ".chunk.js";
};